
export default class NewAccountFormConfiguration {
    public title : string = "";
    public description : string = "";
    public firstnameLabel : string = "";
    public firstnamePlaceholder : string = "";
    public lastnameLabel : string = "";
    public lastnamePlaceholder : string = "";
    public emailLabel : string = "";
    public emailPlaceholder : string = "";
    public fileMaxSize: number = 7000000; //MB
    public fileToLargeValidationMessage: string = "";
    public fileLabel : string = "";
    public filePlaceholder : string = "";
    public identitycardLabel : string = "";
    public identycardExtraInformation : string = "";
	public identityCardAddFileLabel : string = "";
    public identityCardDragFileLabel : string = "";
    public consentLabel : string = "";
    public sendButton : string = "";
    public redirectPageURL : string = "";
    public privacyPageURL : string = "";
    public privacyPageLabel : string = "";
    public fileUploadAllowedFormatsLabel : string = "";
}